/* @flow weak */

'use strict';

const React = require('react');
const ControlMixin = require('../../mixins/ControlMixin.jsx');
const SwearWords = require('../../content/SwearWords.json');
const SwearStrings = require('../../content/SwearStrings.json');

const _ = require('lodash');
const Config = require('../../configs/Config.js');
const Loader = require('../../loaders');
const ln = Loader.ln || 'en_US';

const TextInput = React.createClass({
  mixins: [ControlMixin],

  getInitialState() {
    return {
      charsLeft: _.get(this.props.question, 'constraints.MaxLength'),
      valid: true,
    };
  },

  changeText(e) {
    let inputValue = e.target.value;
    let maxLength = _.get(this.props.question, 'constraints.MaxLength');

    let answerInput = inputValue.toLowerCase().trim();
    let fullMatch = _.some(SwearWords, (badWord) => {
      return badWord === answerInput;
    });

    let partialMatch = _.some(SwearStrings, (string) => {
      return  _.includes(answerInput, string);
    });

    const regex = /^[A-Za-z0-9 `#!',"\-\.\(\):;\?&<>\/$%\[\]^©+|_°=~@♥®™℠\\*]+$/;

    let valid = !fullMatch && !partialMatch && (inputValue.length < 1 || regex.test(inputValue));

    this.setState({valid});

    if (!valid) {
      return;
    }

    if (maxLength) {
      let valueLength = _.get(inputValue, 'length');
      let charsLeft = maxLength - valueLength;

      if (charsLeft < 0) {
        return;
      }

      this.setState({
        charsLeft: charsLeft
      });
    }

    this.handleChangeText(valid ? inputValue : null);
  },

  render() {
    let maxLength = _.get(this.props.question, 'constraints.MaxLength');
    let textTransform = _.get(this.props.question, 'constraints.ForceUppercase') ? ' uc-transform' : '';
    let placeholder = _.get(this.props.question.metadata, `lang.${ln}.DisplayInputPlaceholder`) || '';
    let defaultValue = _.get(this.props.question.metadata, 'TextDefaultValue') || '';
    let questionName = _.get(this.props.question, `metadata.lang.${ln}.DisplayName`) || _.get(this.props.question, 'name');

    return (
      <div className={'uc-control uc-c-textinput' + textTransform}>
        <div className='uc-part-price'>{this.displayPrice(_.first(this.props.parts))}</div>
        <div className="uc-constraint-message uc-error" style={{ display: this.state.valid ? 'none' : 'block'}}>
          This text is not allowed.
        </div>
        <input
          aria-label={questionName}
          type="text"
          placeholder={placeholder}
          tabIndex={this.props.tabIndex}
          value={this.state.textInput || defaultValue}
          onChange={this.changeText}
          onBlur={this.handleBlur}
          disabled={this.state.locked} />
        {
          maxLength ? <div className="uc-chars-left">{this.state.charsLeft} {(Config.features.charactersLeftText[ln] || onfig.features.charactersLeftText['en_US'])}</div>
          : null
        }
      </div>
    );
  }
});

module.exports = TextInput;


// WEBPACK FOOTER //
// ./src/base/scripts/components/controls/TextInput.jsx